<template>
  <div class="payment-simple">
    <div v-show="showForm">
      <h3 class="main_question">{{ $t('Kart Bilgileri') }}</h3>

      <StripeElements
        v-if="elementsOptions.clientSecret"
        :stripe-key="stripeKey"
        :instance-options="instanceOptions"
        :elements-options="elementsOptions"
        #default="{ elements }"
        ref="elms"
      >
        <StripeElement type="payment" :elements="elements" :options="paymentOptions" ref="payment" />
      </StripeElements>
    </div>

    <PrivacyGlobalModal v-if="this.$i18n.locale === 'tr'" :is-customer="true" />
  </div>
</template>

<script>
import { StripeElement, StripeElements } from 'vue-stripe-elements-plus';
import StripeStore from '../stores/stripe';
import PrivacyGlobalModal from '@/components/modals/policies/PrivacyGlobalModal';

export default {
  components: {
    StripeElements,
    StripeElement,
    PrivacyGlobalModal,
  },
  props: {
    showForm: {
      type: Boolean,
      default: true,
    },
    appliedAmount: {
      type: Number,
      default: 0,
    },
    form: {
      product_id: [],
      token: null,
      promotion_code: null,
      commit: false,
    },
    company: {},
    subtotal: null,
    currency: null,
  },
  data() {
    return {
      stripeKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      instanceOptions: {
        // https://stripe.com/docs/js/initializing#init_stripe_js-options
        locale: this.$i18n.locale,
      },
      elementsOptions: {
        clientSecret: null,
        // https://stripe.com/docs/js/elements_object/create#stripe_elements-options
      },
      paymentOptions: {},
    };
  },

  created() {
    this.$validator = this.$parent.$validator;
    this.startWaiting();
  },

  methods: {
    setIntent(secret) {
      this.elementsOptions.clientSecret = secret;
      this.$nextTick(() => {
        this.$refs.elms.elements.update({
          clientSecret: secret,
        });
        this.$refs.elms.elements.fetchUpdates();
      });
    },
    getIntent() {
      const form = JSON.parse(JSON.stringify(this.form));
      if (this.appliedAmount) {
        form.wallet_amount = this.appliedAmount;
      }
      if (this.isWebView) {
        form.is_mobile = true;
      }

      this.$emit('set-loading', true);
      StripeStore.dispatch('getClientSecretFromStripe', { companyId: this.company.id, form: form })
        .then((s) => {
          this.setIntent();
          this.endWaiting();
        })
        .finally((s) => {
          this.$emit('set-loading', false);
        });
    },
    pay() {
      // ref in template
      const elementsComponent = this.$refs.elms;
      // const paymentComponent = this.$refs.payment

      // Get stripe element
      // const stripeElement = paymentComponent.stripeElement

      elementsComponent.instance
        .confirmPayment({
          elements: elementsComponent.elements,
          confirmParams: {
            return_url: process.env.VUE_APP_API_BASE_URI + 'stripe-verify',
          },
        })
        .then(({ error }) => {
          this.endWaiting();
          if (error.message) {
            this.$toasted.error(error.message);
            this.sendHubspotCardErrorMessage(error.message, this.subtotal, this.currency);
          }
        });
    },
  },
};
</script>
